import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { NAME_PATTERN } from './validation-patterns';

/**
 * Reusable name validator for reactive forms.
 * Accepts letters (including Unicode accented characters), spaces, hyphens, and apostrophes.
 * Valid examples: "John", "Mary Jane", "Jean-Pierre", "O'Brien", "José", "François"
 * Usage: nameValidator()
 */
export function nameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value == null || value === '') {
      return null; // Don't validate empty values, use required if needed
    }
    if (value.trim().length === 0) {
      return { name: { valid: false, message: 'Name cannot be only whitespace.' } };
    }
    return NAME_PATTERN.test(value)
      ? null
      : { name: { valid: false, message: 'Name must contain only letters, spaces, hyphens, or apostrophes.' } };
  };
}
